import React, { Component } from "react";
import _ from "lodash";
import anime from "animejs";
import { BackgroundImage, MyWaypoint, FeatherLoop, Image } from "../components";
import { withRedux } from "../hoc";

const img01 = `${process.env.PUBLIC_URL}/assets/images/about-page/image/about-01.jpg`;
const img02 = `${process.env.PUBLIC_URL}/assets/images/about-page/image/about-02.jpg`;
const img03 = `${process.env.PUBLIC_URL}/assets/images/about-page/image/about-03.jpg`;
const img04 = `${process.env.PUBLIC_URL}/assets/images/about-page/image/about-04.jpg`;
const img05 = `${process.env.PUBLIC_URL}/assets/images/about-page/image/about-05.jpg`;
const img06 = `${process.env.PUBLIC_URL}/assets/images/about-page/image/about-06.jpg`;
const imgBanner = `${process.env.PUBLIC_URL}/assets/images/about-page/image/About-banner.jpg`;
const feather1 = `${process.env.PUBLIC_URL}/assets/images/about-page/feather.png`;
const feather2 = `${process.env.PUBLIC_URL}/assets/images/about-page/feather-purple.png`;
const feather3 = `${process.env.PUBLIC_URL}/assets/images/about-page/feather-pink.png`;
// const feather4 = `${process.env.PUBLIC_URL}/assets/images/about-page/feather1.png`;
const feather5 = `${process.env.PUBLIC_URL}/assets/images/about-page/feather3.png`;

const mapStateToProps = (state) => {
  return {
    t: _.get(state, "t"),
    language: _.get(state, "language"),
  };
};

const data = [
  {
    title: {
      en: "Tiffany’s Show started out as a small bar in Pattaya.",
      th: "การแสดงทิฟฟานี่โชว์เริ่มต้นครั้งแรกจากในบาร์เล็กๆในเมืองพัทยา",
      cn: "蒂芬妮秀最早是开始在芭达雅的一家小酒吧",
    },
    description: {
      en:
        "The first show was created just for a birthday party by Mr. Suparb Sangkumchoo but the vision turned into a spectacular reality when Mr. Vichai Lertritraugsin saw the potential and promoted it as the first transgender cabaret show in Thailand. When word of mouth spread, lots of tourists came to see the show night after nights until the bar’s capacity could not cope with more guests. It was when Mr. Sutham Phanthusak joined in making Tiffany’s Show a cabaret theatre with 500 seat capacity and being able to serve tourists from around the world.",
      th:
        "การแสดงครั้งแรกนั้นถูกรังสรรค์ขึ้นสำหรับงานเลี้ยงวันเกิดโดยคุณสุภาพ แสงคำชู ซึ่งวิสัยทัศน์กลายเป็นความจริงที่น่าทึ่ง เมื่อคุณวิชัย เลิศฤทธิ์เรืองสิน เห็นศักยภาพที่ดีของการแสดง จึงริเริ่มส่งเสริมและประชาสัมพันธ์โชว์ในฐานะการแสดงคาบาเร่ต์ของสาวทรานส์เจนเดอร์ครั้งแรกในประเทศไทย ซึ่งก่อให้เกิดกระแสการเล่าขานและบอกต่อกันปากต่อปาก ส่งผลให้ เกิดกระแสนักท่องเที่ยวจากทั่วทุกมุมโลกเข้ามารับชมการแสดงอย่างไม่ขาดสายทุกค่ำคืนจนกระทั่งความสามารถของบาร์ไม่สามารถรองรับจำนวนผู้เข้าชมได้เพียงพอ คุณสุธรรม พันธุศักดิ์ จึงริเริ่มก่อตั้งโรงละครทิฟฟานี่โชว์ พัทยาด้วยความจุขนาด 500 ที่นั่งเพื่อบริการและรองรับนักท่องเที่ยวที่หลั่งไหลมาจากทั่วโลก",
      cn:
        "第一场的演出是由Suparb Sangkumchoo先生为一个生日聚会而创造的，但是当Vichai Lertritraugsin先生看到了这种表演后觉得深具潜力，于是想将其推广为泰国的第一个跨性别歌舞表演，后来果真实现了这个愿望。在大家 口耳相传后，许多游客纷纷前往观看演出，直到酒吧已无法再容纳更多的客人。 接着在Sutham Phanthusak先生加入后创建了一个可以容纳500人的剧院，开始为来自世界各地的观光游客提供服务。",
    },
    image: img01,
  },
  {
    title: {
      en: "The World’s First Cabaret Theatre",
      th: "โรงละครคณะคาบาเร่ต์สาวทรานส์เจนเดอร์แห่งแรกในโลก",
      cn: "全世界第一个跨性别秀剧院",
    },
    description: {
      en:
        "The beginning of the journey would never be possible without our stars in the show who dared to create the difference and relentlessly surprised audience every night in the spotlight as they deserve nothing less than to be called THE LEGEND.",
      th:
        "จุดเริ่มต้นของการเดินทางเส้นทางการแสดงคาบาเร่ต์จะเป็นไปไม่ได้เลยหากไม่มีนักแสดงดาวเด่นของเรา ผู้ซึ่งมีความกล้าที่จะสร้างความแตกต่างอย่างผู้นำและพร้อมที่จะสร้างความประหลาดใจแก่ผู้ชมท่ามกลางแสงสปอตไลท์ในทุกค่ำคืน ดาวเด่นเหล่านั้นคือแท้จริง",
      cn:
        "如果没有我们节目中的明星们敢于创造与众不同，并每晚在聚光灯下无休止地吸引观众，这个被称为“传奇”的旅程将永远不可能开始。",
    },
    image: img02,
  },
  {
    description: {
      en:
        "Deriving from a bar, Tiffany’s Show Pattaya became the World’s First Cabaret Theatre creating famous shows e.g. Mirror Mirror, First Be, Big Spender, Coming to America, The Last Emperor and many more. Mr. Sutham Phanthusak envisioned that the shows could draw international audiences",
      th:
        "ริเริ่มมาจาการแสดงในบาร์ การแสดงทิฟฟานี่โชว์ พัทยา กลายเป็นโรงละครคณะคาบาเร่ต์สาวทรานส์เจนเดอร์แห่งแรกของโลกโดยมีการรังสรรค์การแสดงที่มีชื่อเสียงและโด่งดังต่างๆ อาทิ Mirror Mirror, First Be, Big Spender, Coming to America, The Last Emperor และอื่นๆอีกมากมาย ซึ่งคุณสุธรรม พันธุศักดิ์ ผู้ซึ่งมีวิสัยทัศน์และเล็งเห็นว่าการแสดงทิฟฟานี่โชว์ พัทยาจะสามารถดึงดูดผู้ชมจากทั่วโลกได้",
      cn:
        "从酒吧起家，蒂芬妮秀蜕变为全世界的第一个歌舞剧院，并创造了非常多知名的节目，例如魔镜魔镜、首先是、大富豪、来去美国、末代皇帝等不胜枚举。Sutham Phanthusak先生心想，这些节目可以吸引国际观众，",
    },
    image: img03,
  },
  {
    description: {
      en:
        "So he started marketing the business internationally through meetings and exhibitions. It was quite a challenge at first to introduce a transgender cabaret to the world but believing in the potential, Tiffany’s Show overcame prejudice and became so popular drawing thousands of tourists, performing 8 shows a day and that was when the renovation was planned.",
      th:
        "ดังนั้น คุณสุธรรม พันธุศักดิ์จึงได้ริเริ่มการทำการตลาดในระดับนานาชาติผ่านการเข้าร่วมประชุมสัมนาและการประชาสัมพันธ์ในงานแสดงนิทรรศการ ซึ่งเป็นความท้าทายเนื่องจากเป็นการประชาสัมพันธ์การแสดงคณะคาบาเร่ต์สาวทรานส์เจนเดอร์เป็นครั้งแรกในระดับนานาชาติ ทั้งนี้ เกิดจากความเชื่อมั่นในศักยภาพของการแสดงทิฟฟานี่โชว์ พัทยา ทำให้การแสดงทิฟฟานี่โชว์ พัทยาสามารถก้าวข้าวความอคติต่างๆในอดีต และกลายมาเป็นการแสดงคณะคาบาเร่ต์สาวทรานส์เจนเดอร์ที่มีชื่อเสียงที่สุด ซึ่งเปิดการแสดงถึง 8 รอบต่อวัน และดึงดูดนักท่องเที่ยวจากทั่วโลกจำนวนหลายพันคนต่อวัน และนั่นคือบ่อเกิดแห่งการวางแผนการพัฒนาโรงละครทิฟฟานี่โชว์ พัทยาเพื่อรองรับผู้ชมจากทั่วทุกมุมโลก",
      cn:
        "因此他开始透过会议和展览在国际上进行业务行销。 起初，向全世界介绍跨性别歌舞表演是一个巨大的挑战，但凭着这股潜力，蒂芬妮秀的表演克服了偏见，变得如此地受欢迎，吸引了成千上万的游客，每天必须进行8场的表演，这也成为了后续翻新计划的起因。",
    },
    image: img04,
  },
];

const data2 = {
  en:
    "The renovation was constructed while the shows were still running. The new design added mezzanine and balcony floor as well as the outside balcony, fountain landmark, the signature dome and seats up to 800-person capacity to be able to perform 3 times a day. However, the millennium also came with SARS outbreak which created impact on the number of tourist arrivals and that was when Tiffany’s Show started to expand to European, American and other countries as well.",
  th:
    "การพัฒนาโรงละครด้วยการออกแบบใหม่พร้อมทั้งเพิ่มส่วนที่นั่งชั้นลอยภายในโรงละคร เพิ่มส่วนต้อนรับระเบียงด้านนอก มีน้ำพุและลักษณะหลังคารูปโดมซึ่งเป็นสัญลักษณ์ของโรงละครทิฟฟานี่โชว์ พัทยา และเพิ่มจำนวนที่นั่งเป็น 800 ที่นั่งเพื่อความพร้อมในการรองรับนักท่องเที่ยวจำนวน 3 รอบต่อวัน อย่างไรก็ตาม ยุคเดอะมิลเลนเนียมก็มาพร้อมกับโรคซาร์สซึ่งส่งผลกระทบต่อจำนวนนักท่องเที่ยวที่เดินทางเข้าสู่ประเทศไทยและเมืองพัทยา และนั่นก็เป็นจุดกำเนิดในการปรับแผนการตลาดของการแสดงทิฟฟานี่โชว์ พัทยาในการประชาสัมพันธ์เพื่อขยายฐานนักท่องเที่ยวไปยังทวีปยุโรป อเมริกาและอีกหลายๆประเทศทั่วโลก",
  cn:
    "翻新工程期间并未中断营业， 新增加了夹层楼座位、户外阳台、喷泉地标、标志性圆顶和可容纳800人的座位，每天进行3场演出。 然而，千禧年之后也爆发了SARS疫情，这对亚洲游客的来客数产生了影响，于此同时蒂芬妮秀开始扩展业务到欧洲、美洲和其他地区。",
};

const data3 = {
  en:
    "Tiffany’s Show Pattaya took part in promoting Thailand’s tourism by using technologies, arts, creativities, talents and most importantly standing strong in the vision that Thai products can enter the world market. It has already been 4 decades that Tiffany’s Show Pattaya theatre has been running and opening up the opportunities for a lot of talent to shine and be proud of who they can become.",
  th:
    "การแสดงทิฟฟานี่โชว์ พัทยามีส่วนร่วมในการส่งเสริมการท่องเที่ยวของประเทศไทยโดยใช้เทคโนโลยีทางด้านศิลปะความสร้างสรรค์ความสามารถและที่สำคัญที่สุดคือวิสัยทัศน์ที่แข็งแกร่งว่าผลิตภัณฑ์ที่ริเริ่มและพัฒนาโดยคนไทยสามารถเข้าสู่ตลาดโลกได้ และเป็นเวลากว่า 4 ทศวรรษแล้ว ที่โรงละครทิฟฟานี่โชว์ พัทยาเปิดดำเนินการและเปิดโอกาสให้ผู้ที่มีพรสวรรค์จำนวนมากได้มีความภาคภูมิใจในสิ่งที่พวกเขาเป็นและได้รับโอกาสในสังคมพร้อมเปล่งประกายบนเวทีระดับสากล",
  cn:
    "芭达雅蒂芬妮秀透过科技、艺术、创造力和才华，来致力于促进泰国旅游业的发展，最重要的是坚信泰国旅游产品可以进入全世界市场。 芭达雅蒂芬妮秀已开业40年之久，它为许多才华横溢的人提供了表演机会，并让她们因为能做自己而感到骄傲。",
};

const anniversaryWord = {
  en: (
    <h3>
      45<sup>th</sup> Year Anniversary
    </h3>
  ),
  th: <h3>ครบรอบ 45 ปี</h3>,
  cn: <h3>45周年</h3>,
};

const data4 = {
  en:
    "Be a part of the celebration by enjoying the show and telling the world that you’ve finally been here at Tiffany’s Show Pattaya!",
  th:
    "ร่วมเป็นส่วนหนึ่งในการเฉลิมฉลองที่ยิ่งใหญ่เพื่อบอกให้คนทั้งโลกรู้ว่าคุณมาถึงแล้วที่ โรงละครทิฟฟานี่โชว์ พัทยา!",
  cn:
    "来欣赏表演并且告诉全世界您终于来到芭达雅蒂芬妮秀，共襄盛举我们的欢庆吧！",
};

@withRedux(mapStateToProps)
class About extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="about-page">
        <div className="container-header">
          <BackgroundImage image={imgBanner} />
          <div className="item-content">
            <h1>
              THE
              <br />
              LEGEND
            </h1>
            <h2>
              45<sup>th</sup> YEAR
            </h2>
            <h3>TIFFANY’S SHOW PATTAYA</h3>
          </div>
          <div className="item-description">
            <p>FIRST TIFFANY’S SHOW POSTER</p>
            <p>LIVE IN GEREMANY STARRING BY Mr.Suparb Sangkamchoo</p>
          </div>
        </div>
        <div className="container-content">
          {_.map(data, (item, index) => {
            const isContentLeft = index % 2 === 0;
            return (
              <div key={index} className="item-block">
                <div className="row no-gutters align-items-center">
                  <div
                    className={`col-lg-6 ${
                      isContentLeft && window.innerWidth > 700 ? "" : "order-2"
                    }`}
                  >
                    <div
                      className={`item-content ${
                        isContentLeft ? "content-left" : "content-right"
                      }`}
                    >
                      {_.get(item, "title") && (
                        <MyWaypoint
                          anime={[
                            () =>
                              anime({
                                targets: document.querySelectorAll(
                                  ".about-page .container-content .item-block h3"
                                )[index],
                                translateY: [50, 0],
                                opacity: [0, 1],
                                easing: "easeInOutSine",
                                duration: 1500,
                                delay: 100,
                              }),
                          ]}
                        >
                          <h3 className={index === 0 ? "long-title" : ""}>
                            {t(_.get(item, "title"))}
                            {/* <span className="subtitle">
                              {" "}
                              {_.get(item, "subtitle")}
                            </span> */}
                          </h3>
                        </MyWaypoint>
                      )}
                      {index === 3 && (
                        <Image className="feather-4" src={feather2} alt="" />
                      )}
                      <MyWaypoint
                        anime={[
                          () =>
                            anime({
                              targets: document.querySelectorAll(
                                ".about-page .container-content .item-block .description"
                              )[index],
                              translateY: [50, 0],
                              opacity: [0, 1],
                              easing: "easeInOutSine",
                              duration: 1800,
                              delay: 200,
                            }),
                        ]}
                      >
                        <p className="description">
                          {t(_.get(item, "description"))}
                        </p>
                      </MyWaypoint>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="item-image">
                      <MyWaypoint
                        anime={[
                          () =>
                            anime({
                              targets: document.querySelectorAll(
                                ".about-page .container-content .item-block .background-image-component"
                              )[index],
                              translateY: [-20, 0],
                              opacity: [0, 1],
                              easing: "easeInOutSine",
                              duration: 1800,
                              delay: 300,
                            }),
                        ]}
                      >
                        <BackgroundImage image={_.get(item, "image")} />
                      </MyWaypoint>
                      {index === 0 && (
                        <Image className="feather-1" src={feather1} alt="" />
                      )}
                      {index === 1 && (
                        <Image className="feather-2" src={feather2} alt="" />
                      )}
                      {index === 2 && (
                        <Image className="feather-3" src={feather3} alt="" />
                      )}
                    </div>
                  </div>
                </div>
                <FeatherLoop index={index} />
              </div>
            );
          })}
          <div className="item-block full-block">
            <div className="item-content">
              <MyWaypoint
                anime={[
                  () =>
                    anime({
                      targets: document
                        .querySelectorAll(
                          ".about-page .container-content .item-block"
                        )[4]
                        .querySelector("h3"),
                      translateY: [20, 0],
                      opacity: [0, 1],
                      easing: "easeInOutSine",
                      duration: 1800,
                      delay: 300,
                    }),
                ]}
              >
                <h3>{t("The Millennium")}</h3>
              </MyWaypoint>
              <MyWaypoint
                anime={[
                  () =>
                    anime({
                      targets: document
                        .querySelectorAll(
                          ".about-page .container-content .item-block"
                        )[4]
                        .querySelector(".description"),
                      translateY: [50, 0],
                      opacity: [0, 1],
                      easing: "easeInOutSine",
                      duration: 1500,
                      delay: 500,
                    }),
                ]}
              >
                <p className="description">{t(data2)}</p>
              </MyWaypoint>
            </div>
            <Image src={img05} alt="" />
            <Image className="feather-5" src={feather2} alt="" />
            <Image className="feather-6" src={feather5} alt="" />
          </div>
          <div className="item-block full-block">
            <div className="item-content">
              <MyWaypoint
                anime={[
                  () =>
                    anime({
                      targets: document
                        .querySelectorAll(
                          ".about-page .container-content .item-block"
                        )[5]
                        .querySelector("h3"),
                      translateY: [20, 0],
                      opacity: [0, 1],
                      easing: "easeInOutSine",
                      duration: 1800,
                      delay: 300,
                    }),
                ]}
              >
                {t(anniversaryWord)}
              </MyWaypoint>
              <MyWaypoint
                anime={[
                  () =>
                    anime({
                      targets: document
                        .querySelectorAll(
                          ".about-page .container-content .item-block"
                        )[5]
                        .querySelectorAll(".description"),
                      translateY: [50, 0],
                      opacity: [0, 1],
                      easing: "easeInOutSine",
                      duration: 1500,
                      delay: 500,
                    }),
                ]}
              >
                <p className="description">{t(data3)}</p>
                <p className="description">{t(data4)}</p>
              </MyWaypoint>
            </div>
            <Image src={img06} alt="" />
          </div>
        </div>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/pages/About.js